import Call from '../Call';
import {objToQs} from '../Utils';

const Pushapi = {
    getExtended(filters, path = '') {
        return Call(`pushapiExtended/${path}?${objToQs(filters)}`);
    },

    getSubids(filters) {
        return Call(`pushapiExtended/subid?${objToQs(filters)}`);
    }
}

export default Pushapi;


// WEBPACK FOOTER //
// ./src/services/API/components/Pushapi.js